import React from "react";
import "../css/userProfile.css";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useState,useEffect } from "react";
import { Checkmark } from 'react-checkmark'
import RingLoader from "react-spinners/RingLoader"
import "../css/loading.css"


function UserProfile() {

    const params = useParams();
    const email = params.email;

    const [user, setUser] = useState({});
    const [busy, setBusy] = useState(false);
   

    const fetchData = async () => {
          try {
            setBusy(true)
            const response = await fetch(`https://petme.onrender.com/user/adopterInfo?email=${email}`); 
            setBusy(false)
            const data = await response.json();
            setUser(data[0]);
          } catch (error) {
            console.error(error);
          }
        };
  
    useEffect(() => {
      fetchData();
    }, []);
    


    if(busy){
        return(
          <div className="loader-container" >
        <RingLoader color="#36d7b7" loading size={90} />
        <h1 className="loading-heading">Loading....</h1>
      </div>
        )
      }

    return (
        <div>
            <div className="userProfile-div">
                <div class="userProfile-bg_img"></div>
                <div class="userProfile-content">
                    <h2 className="userProfile-heading">Profile</h2>
                    <div className="userProfile-columns">
                        <div className="userProfile-userImage">
                            <i className="userProfile-Img fa-solid fa-user"></i>
                            {/* <img class="profile-profileImg" src={props.userImg} alt="profileImage" /> */}
                        </div>
                        <div className="userProfile-userDetails">
                            <p className="userProfile-userName">{user.firstname} {user.name}</p>
                            <p className="userProfile-userEmail">{user.email}</p>
                            <Link id="userProfileEditNavlink" className="userProfile-editNavlink" to={`/editProfile/${email}`}>
                                <button type="button" class="userProfile-editBtn">EDIT PROFILE</button>
                            </Link>
                        </div>
                    </div>
                    <div className="userProfile-statusDiv">
                        <h2 className="userProfile-statusHeading">Pet Adoption Status</h2>
                        {/* <input type="checkbox" id="quetionnaire" name="status" value="quetionnaire" className="userProfile-statusCheckbox" /> */}
                        <label className="userProfile-statusLabel" for="quetionnaire">
                            <div className="userProfile-fieldStatusDiv">
                           
                            <p className="userProfile-field">{user.question && <Checkmark size={15} />}Questionnaire</p>
                            </div>
                        </label>
                        <br />
                        {/* <input type="checkbox" id="homeVisit" name="status" value="homeVisit" className="userProfile-statusCheckbox"/> */}
                        <label className="userProfile-statusLabel" for="homeVisit">
                            <div className="userProfile-fieldStatusDiv">
                                <p className="userProfile-field"> {user.visit && <Checkmark size={15} />}Home Visit</p>
                               
                                {/* <p className="userProfile-fieldStatus">Under process or to be scheduled</p> */}
                            </div>
                        </label>

                        {user.visit&&(<p className="userProfile-status">Congratulations! Your request for adopting the pet has been approved.</p>)}
                        {/* <p className="userProfile-status">Sorry, You reaquest for adopting the pet has been disapproved.</p> */}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UserProfile
